const prod = {
 url: {
    BASE_URL: `${window.location.origin}/api`
 }
};

const dev = {
 url: {
    BASE_URL: 'http://localhost:8000/api',
 }
};

export const config = window._env_.REACT_APP_NODE_ENV === 'development' ? dev : prod;

export const showHeatMapOnBroccoliDashboard = window._env_.REACT_APP_SHOW_HEAT_MAP_BROCCOLI_DASHBOARD !== 'false';
export const showPipelineLogsTab = window._env_.REACT_APP_SHOW_PIPELINE_LOGS_TAB !== 'false';
export const showVisualisationDashboard = window._env_.REACT_APP_SHOW_VISUALISATION_DASHBOARD !== 'false';
export const supabaseURL = window._env_.REACT_APP_SUPABASE_URL;
export const supabaseAPIKey = window._env_.REACT_APP_SUPABASE_API_KEY;
export const sentryRelease = window._env_.REACT_APP_SENTRY_RELEASE;
export const sentryDSN = window._env_.REACT_APP_SENTRY_DSN;
export const sentryEnv = window._env_.REACT_APP_SENTRY_ENV;
export const showRecommendationFollowSpinachDashboard = window._env_.REACT_APP_SHOW_RECOMMENDATION_FOLLOW_SPINACH_DASHBOARD !== 'false';
export const broccoliHarvestOptimiserSupabaseURL = window._env_.REACT_APP_BROCCOLI_HARVEST_OPTIMISER_SUPABASE_URL;
export const broccoliHarvestOptimiserSupabaseAPIKey = window._env_.REACT_APP_BROCCOLI_HARVEST_OPTIMISER_SUPABASE_API_KEY;
export const reportsSupabaseUrl = window._env_.REACT_APP_REPORTS_SUPABASE_URL;
export const reportsSupabaseAPIKey = window._env_.REACT_APP_REPORTS_SUPABASE_API_KEY;